import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  DashboardHomeContainer,
  DashboardHomeMain,
  DashboardHomeInvestmentOpportunity,
  Welcome,
  Campaigns
} from './home.styles';
import Sponsors from 'src/components/Layout/sponsors/sponsors';
import Banner from 'src/components/shared/Banner/Banner';
import ModalCompanyDetailInvestPay from 'src/components/shared/modals/companyDetailInvestPay/companyDetailInvestPay';
import ModalWithdrawVirtualAccount from 'src/components/shared/modals/withdrawVirtualAccount/withdrawVirtualAccount';
import ModalSuccessWithdrawVirtualAccount from 'src/components/shared/modals/successWithdrawVirtualAccount/successWithdrawVirtualAccount';
import { getApplicantFiles, getApplicantPLD } from 'src/graphql/customized_queries';

export default function DashboardHome() {
  const [companyDetailInvestPay, setCompanyDetailInvestPay] = useState(false);
  const [withdrawVirtualAccount, setWithdrawVirtualAccount] = useState(false);
  const [successWithdrawVirtualAccount, setSuccessWithdrawVirtualAccount] = useState(false);
  const [simafValid, setSimafValid] = useState(null);
  const [filesValidator, setFilesValidator] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.currentUser);
  //Banner
  const [showBanner, setShowBanner] = useState(true);
  const onboardingFinished = useSelector((state) => state.user.onboardingFinished);
  const currentStep = useSelector((state) => state.user.currentStep);
  const userId = user.id;
  const handleBannerClick = () => {
    let route;
    switch (currentStep) {
      case 1:
        route = navigate('/solicitante/onboarding-data');
        break;
      case 2:
        route = navigate('/solicitante/onboarding-creditInfo');
        break;
      case 3:
        route = navigate('/solicitante/onboarding-analysis');
        break;
      case 4:
        route = navigate('/solicitante/onboarding-phone');
        break;
      default:
        route = navigate('/solicitante/onboarding-data');
    }
  };
  const handleDismiss = () => {
    setShowBanner(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getApplicantFiles,
          variables: { id: userId }
        });
        const files = data.getFile.areBusinessDocumentsUpload;
        setFilesValidator(files);
      } catch (error) {
        console.error(error);
      }
      try {
        const { data } = await API.graphql({
          query: getApplicantPLD,
          variables: { id: userId }
        });
        const simaf = data.getApplicant.isPLDApproved;
        setSimafValid(simaf);
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserData();
  }, []);

  return (
    <DashboardHomeContainer>
      <ModalCompanyDetailInvestPay showModalCompanyDetailInvestPay={companyDetailInvestPay} />
      <ModalWithdrawVirtualAccount showModalWithdrawVirtualAccount={withdrawVirtualAccount} />
      <ModalSuccessWithdrawVirtualAccount
        showModalSuccessWithdrawVirtualAccount={successWithdrawVirtualAccount}
      />
      <DashboardHomeMain>
        {!onboardingFinished && showBanner && (
          <Banner onButtonClick={handleBannerClick} onDismiss={handleDismiss} />
        )}
        <Welcome>
          <div>
            <h2>¡Bienvenido a FinSphera!</h2>
            <h3>La opción más fácil para solictar créditos</h3>
          </div>
          <h4>
            ¡Ya eres parte de la comunidad de Finsphera y estás listo para impactar positivamente a
            nuestra Comunidad y Medio Ambiente!.
          </h4>
        </Welcome>
      </DashboardHomeMain>
      <Campaigns>
        {filesValidator !== null &&
          simafValid !== null &&
          (filesValidator === false || simafValid === '0' ? (
            <div>
              <h4>
                En un lapso no mayor a 24hrs. recibirás un correo con la notificación de que tu
                cuenta está lista para comenzar con la creación de tus campañas. Mientras tanto
                puedes apoyarnos proporcionando los siguientes documentos en{' '}
                <Link to="/solicitante/dashboard/mi-perfil">esta liga</Link>
              </h4>
            </div>
          ) : (
            <div>
              <h3>Solicita inversión a través de Finsphera</h3>
              <Link to="/solicitante/dashboard/campañas">Ir a campañas</Link>
              <p>
                Recuerda que al ser un cliente cumplido, puedes subir tu nivel de crédito y obtener
                mejores tasas de interés.
              </p>
            </div>
          ))}
      </Campaigns>
      <Sponsors />
      <DashboardHomeInvestmentOpportunity>
        <div>
          <h2>Hasta que la incompatibilidad financiera nos separe</h2>
          <p>
            Los pesos y los centavos son un ingrediente de relevancia en una relación amorosa
            estable, se puede observar desde la clásica angustia por decidir si dar o no obsequio en
            San Valentín, el costo que...
          </p>
          <Link to="/">Visita nuestro blog de noticias</Link>
        </div>
      </DashboardHomeInvestmentOpportunity>
    </DashboardHomeContainer>
  );
}
